import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const RestaurantTypes: ParentMenuProps = {
  label: 'Restaurant Types',
  description: 'Toast solutions for any concept',
  heapClass: 'ca_topnav_rx',
  showcaseMobile: true,
  showcaseEntries: [
    {
      title: 'Switching to Toast',
      description:
        'Feeling limited by your current tech? Toast is here for you, starting with easy onboarding.',
      heapClass: 'ca_nav_switch',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/switching-to-toast-article-thumbnail.jpg',
      badge: {
        label: 'Featured',
        color: 'bg-yellow-25'
      },
      icon: 'before:content-icon-solutions-contactless',
      url: '/restaurant-pos/switch-to-toast'
    },
    {
      title: 'Opening a New Restaurant',
      description:
        "We'll take care of the technology, so you can focus on what matters most.",
      heapClass: 'ca_nav_nro',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/opening-a-new-restaurant-article-thumbnail.jpg',
      badge: {
        label: 'Featured',
        color: 'bg-yellow-25'
      },
      icon: 'before:content-icon-solutions-back-of-house',
      url: '/restaurant-pos/new-restaurant-opening'
    }
  ],
  subMenus: [
    {
      label: 'Restaurant POS',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Solutions for every size, concept and ambition.',
          heapClass: 'ca_nav_rxpos',
          icon: 'before:content-icon-restaurant-types-restaurant-pos',
          url: '/restaurant-pos'
        }
      ]
    },
    {
      label: 'Cafe & Bakery',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Make speedy, accurate service second nature.',
          heapClass: 'ca_nav_cafe',
          icon: 'before:content-icon-cafe-bakery',
          url: '/restaurant-pos/cafe-bakery'
        }
      ]
    },
    {
      label: 'Bar & Lounge',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'From happy hours to last calls, Toast has your back.',
          heapClass: 'ca_nav_bar',
          icon: 'before:content-icon-bar-nightclub',
          url: '/restaurant-pos/bar-pos'
        }
      ]
    },
    {
      label: 'Casual Dining',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Designed for higher cheque sizes and more return guests.',
          heapClass: 'ca_nav_casual',
          icon: 'before:content-icon-casual-dining',
          url: '/restaurant-pos/casual-dining'
        }
      ]
    },
    {
      label: 'Fine Dining',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Deliver exceptional service from first course to last.',
          heapClass: 'ca_nav_fine',
          icon: 'before:content-icon-fine-dining',
          url: '/restaurant-pos/fine-dining'
        }
      ]
    },
    {
      label: 'Quick Service',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'POS system designed for on-the-go service.',
          heapClass: 'ca_nav_qsr',
          icon: 'before:content-icon-restaurant-types-quick-service',
          url: '/restaurant-pos/quick-service-pos-system'
        }
      ]
    },
    {
      label: 'Pizza',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Simplify operations from order to delivery.',
          heapClass: 'ca_nav_pizza',
          icon: 'before:content-icon-pizza',
          url: '/restaurant-pos/pizza-pos'
        }
      ]
    },
    {
      label: 'Fast Casual',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'A fast POS for fast-casual restaurants.',
          heapClass: 'ca_nav_fastcasual',
          icon: 'before:content-icon-restaurant-types-fast-casual',
          url: '/restaurant-pos/fast-casual'
        }
      ]
    },
    {
      label: 'Full Service',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Stay out of the weeds, no matter how busy you get.',
          heapClass: 'ca_nav_fsr',
          icon: 'before:content-icon-fullservice',
          url: '/restaurant-pos/full-service-pos-system'
        }
      ]
    },
    {
      label: 'Hotel Restaurants',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Streamlined service from lobby to suite.',
          heapClass: 'ca_nav_hotel',
          icon: 'before:content-icon-hotel',
          url: '/restaurant-pos/hotel-restaurant'
        }
      ]
    }
  ],
  sectionCTA: {
    title: 'Built for Restaurants',
    description:
      'Toast is designed for restaurant success. Customize Toast to fit the needs of your restaurant type.',
    url: '/restaurant-pos'
  }
}

export default RestaurantTypes
